document.addEventListener("DOMContentLoaded", function () {
    jerseyCollection();
});


let isPreorderTemplate = false;
let templateType = 'regular'; // 'regular', 'cityonly', 'nocity'

function jerseyCollection() {
  window.onload = function () {
      if (typeof collectionData === "undefined") {
          console.error("Collection data is not available.");
          return;
      }

      const data = collectionData;
      let productMap = new Map();
      let variantMap = new Map();
      
      // Determine template type - FIX THIS LOGIC
      if (data.template === "jersey-preorder" || data.template === "jersey-preorder-cityonly") {
          isPreorderTemplate = true;
          templateType = 'cityonly';
      } else if (data.template === "jersey-preorder-nocity") {
          isPreorderTemplate = false;  // NOT a preorder - this is the fix
          templateType = 'nocity';
      } else {
          isPreorderTemplate = false;
          templateType = 'regular';
      }
      
      if (data.template === "jersey-preorder-cityonly") {
          templateType = 'cityonly';
      } else if (data.template === "jersey-preorder-nocity") {
          templateType = 'nocity';
      } else {
          templateType = 'regular';
      }
      
      // Filter products/variants based on template type
      if (templateType === 'cityonly') {
          // Filter to only include products/variants with City color
          data.products = data.products.filter(product => {
              product.variants = product.variants.filter(variant => 
                  variant.color === 'City 26' && variant.hide !== "true"
              );
              return product.variants.length > 0;
          });
      } else if (templateType === 'nocity') {
          // Filter out City color variants
          data.products.forEach(product => {
              product.variants = product.variants.filter(variant => 
                  variant.color !== 'City 26' && variant.hide !== "true"
              );
          });
          // Remove products that have no variants left
          data.products = data.products.filter(product => product.variants.length > 0);
      }
      
      // Rest of initialization...
      initializeProductSelection(data, productMap);
      setupProductSelector(variantMap, data, productMap);
      

      // Check if the URL has a variant parameter
      const urlParams = new URLSearchParams(window.location.search);
      const variantIdFromUrl = urlParams.get('variant');

      // Dispatch initial change event
      document.getElementById("product-select").dispatchEvent(new Event("change"));

      document.getElementById("product-select-target").addEventListener("click", function(e) {
          this.classList.toggle("expanded");
      });

      // Add a slight delay to ensure all options are populated before setting the variant from the URL
      setTimeout(() => {
          if (variantIdFromUrl) {
              // Call selectVariantById after ensuring the options are populated
              selectVariantById(variantIdFromUrl, productMap, variantMap, data);
          }
      }, 0); // Adjust the delay as needed, 0 might be enough

  };
}


function selectVariantById(variantId, productMap, variantMap, data) {
    for (let product of data.products) {
        let foundVariant = product.variants.find(variant => variant.id === variantId);
        if (foundVariant) {
            // Set the product select based on template type
            if (templateType === 'cityonly') {
                // For cityonly, set to player name
                document.getElementById("product-select").value = product.player_name;
            } else {
                // For regular/nocity, set to product title
                document.getElementById("product-select").value = product.title;
            }
            
            document.getElementById("product-select").dispatchEvent(new Event("change"));
            
            // Set the variant radio buttons
            let sizeRadio = document.querySelector(`input[name="size"][value="${foundVariant.size}"]`);
            let colorRadio = document.querySelector(`input[name="color"][value="${foundVariant.color}"]`);
            let styleRadio = document.querySelector(`input[name="style"][value="${foundVariant.style}"]`);
            
            if (sizeRadio) sizeRadio.checked = true;
            if (colorRadio) colorRadio.checked = true;
            if (styleRadio) styleRadio.checked = true;

            handleProductFormChange(variantMap)();
            
            // Update variant details and form
            updateVariantDetails(foundVariant, variantMap);
            
            // Break the loop once the variant is found and processed
            break;
        }
    }
}

function updateVariantDetails(variant) {
  // Set the 'product-variant-id' for the selected variant
  updateProductVariantId(variant.id);
  document.getElementById("price").innerHTML = variant.price;
  updateSlides(variant);

  // Append the variant ID to the URL
  updateUrlWithVariantId(variant.id);
}

function initializeProductSelection(data, productMap) {
    if (templateType === 'cityonly') {
        // Group by player for cityonly template (like preorder)
        let playerMap = new Map();
        
        data.products.forEach((product) => {
            const playerName = product.player_name;
            if (!playerMap.has(playerName)) {
                playerMap.set(playerName, []);
            }
            playerMap.get(playerName).push(product);
        });
        
        let isFirstPlayer = true;
        playerMap.forEach((products, playerName) => {
            let combinedVariants = [];
            let playerNumber = products[0].player_number;
            
            products.forEach(product => {
                const visibleVariants = product.variants.filter(variant => variant.hide !== "true");
                combinedVariants = combinedVariants.concat(visibleVariants);
            });
            
            productMap.set(playerName, combinedVariants);
            
            // Create option for player dropdown
            let option = document.createElement("option");
            option.text = playerName;
            option.value = playerName;
            
            if (isFirstPlayer) {
                option.selected = true;
                isFirstPlayer = false;
            }
            
            document.getElementById("product-select").appendChild(option);
            
            // Create visual selector
            var div = document.createElement("div");
            div.className = "option-selector";
            if (playerMap.size === 1 || isFirstPlayer) {
                div.classList.add("active");
                document.querySelector(".selected-option").textContent = playerName;
            }
            div.innerHTML = "<div class='name'>" + playerName + "</div><div class='number'>#" + playerNumber + "</div>";
            div.dataset.index = Array.from(playerMap.keys()).indexOf(playerName);
            document.querySelector(".dropdown-menu").appendChild(div);
        });
    } else {
        // Original logic for non-preorder templates
        let isFirstProduct = true;
        data.products.forEach((product, index) => {
            const visibleVariants = product.variants.filter(variant => variant.hide !== "true");
            productMap.set(product.title, visibleVariants);
            
            let option = document.createElement("option");
            option.text = product.title;
            option.value = product.title;
            
            if (isFirstProduct) {
                option.selected = true;
                isFirstProduct = false;
            }
            
            document.getElementById("product-select").appendChild(option);
            
            var name = product.player_name;
            var number = product.player_number;
            var div = document.createElement("div");
            div.className = "option-selector";
            if (index === 0) {
                div.classList.add("active");
                document.querySelector(".selected-option").textContent = product.title;
            }
            div.innerHTML = "<div class='name'>" + name + "</div><div class='number'>#" + number + "</div>";
            div.dataset.index = index;
            document.querySelector(".dropdown-menu").appendChild(div);
        });
    }
}

  function setupProductSelector(variantMap, data, productMap, callback) {
    document.getElementById("product-select-target").addEventListener("click", handleOptionSelectorClick);
    document.getElementById("product-select").addEventListener(
      "change",
      handleProductSelectChange(data, variantMap, productMap, callback) // Pass the callback here
    );
}
function handleProductSelectChange(data, variantMap, productMap, callback) {
    return function() {
        let thisProduct;
        let variants;
        
        if (templateType === 'cityonly') {
            // Handle like preorder - by player name
            const playerName = this.value;
            variants = productMap.get(playerName);
            thisProduct = data.products.find(product => product.player_name === playerName);
        } else {
            // Regular product selection
            thisProduct = data.products.find(product => product.title === this.value);
            variants = productMap.get(this.value);
        }
        
        // Clear options based on template
        if (templateType === 'cityonly') {
            ["size", "style"].forEach(function(option) {
                const element = document.getElementById(option + "-options");
                if (element) element.innerHTML = "";
            });
        } else {
            ["size", "color"].forEach(function(option) {
                const element = document.getElementById(option + "-options");
                if (element) element.innerHTML = "";
            });
        }

        let productVendor = thisProduct.vendor;
        let productTags = thisProduct.tags;

        if (Array.isArray(productTags) && productTags.includes('Youth') && productVendor === 'Outerstuff') {
            productVendor = 'Nike';
        }

        document.getElementById("vendor").innerHTML = productVendor;
        
        var sizeSet = new Set();
        var colorSet = new Set();
        var styleSet = new Set();

        // Clear the variant map
        variantMap.clear();

        // Process variants based on template - FIX THIS SECTION
        variants.forEach((variant) => {
            if (variant.hide !== "true") {
                sizeSet.add(variant.size);
                
                if (templateType === 'cityonly') {
                    // For cityonly, extract unique styles from City variants
                    if (variant.style) {
                        styleSet.add(variant.style);
                        var key = variant.size + variant.style;
                    } else {
                        // If no style field, use a default
                        styleSet.add("Swingman"); // or whatever default you want
                        var key = variant.size + "Swingman";
                    }
                } else if (variant.color) {
                    // For regular templates, use color
                    colorSet.add(variant.color);
                    var key = variant.size + variant.color;
                } else {
                    var key = variant.size;
                }

                variantMap.set(key, {
                    id: variant.id,
                    inventory: variant.inventory_quantity,
                    inventory_policy: variant.inventory_policy,
                    price: variant.price,
                    featured_image_alt: variant.featured_image_alt,
                    hide: variant.hide,
                    style: variant.style || "Swingman",
                    color: variant.color || null
                });
            }
        });

        // Populate options
        populateOptions(sizeSet, "size", variantMap, thisProduct);
        
        if (templateType === 'cityonly' && styleSet.size > 0) {
            populateOptions(styleSet, "style", variantMap, thisProduct);
        } else if (colorSet.size > 0) {
            populateOptions(colorSet, "color", variantMap, thisProduct);
        }
        // Handle media based on template
        if (templateType === 'cityonly') {
            // Skip media update or use collection image
        } else {
            handleMedia(thisProduct);
        }
        


        // Find first available non-hidden variant
        for (let [key, variant] of variantMap) {
            if ((variant.inventory > 0 || variant.inventory_policy === 'continue') && variant.hide !== "true") {
                updateVariantDetails(variant, variantMap);
                break;
            }
        }

        handleProductFormChange(variantMap)();

        document.querySelector(".selected-option").textContent = thisProduct.player_name + " #" + thisProduct.player_number;
        
        if (typeof callback === 'function') {
            callback();
        }
    };
}
  
  function handleProductFormChange(variantMap) {
    return function (e) {
        var size = document.querySelector('input[name="size"]:checked')?.value;
        var key;
        
        // Use templateType instead of isPreorderTemplate for key building
        if (templateType === 'cityonly') {
            var style = document.querySelector('input[name="style"]:checked')?.value;
            key = size + (style || '');
        } else {
            var color = document.querySelector('input[name="color"]:checked')?.value;
            key = size + (color || '');
        }
        
        var variant = variantMap.get(key);
        if (variant) {
            updateSlides(variant);
            updateProductVariantId(variant.id);
            updateUrlWithVariantId(variant.id);
            document.getElementById("price").innerHTML = variant.price;
        }
        
        var submitButton = document.querySelector('.product-form__submit');
        var submitButtonSpan = submitButton.querySelector('span');
        
        // Button text based on template type
        if (templateType === 'cityonly') {
            submitButton.classList.remove('disabled');
            submitButton.disabled = false;
            submitButtonSpan.textContent = 'Preorder';
        } else if (templateType === 'nocity') {
            submitButton.classList.remove('disabled');
            submitButton.disabled = false;
            submitButtonSpan.textContent = 'Add to Bag';
        } else {
            // Regular inventory-based logic
            if (variant && (variant.inventory > 0 || variant.inventory_policy === 'continue')) {
                submitButton.classList.remove('disabled');
                submitButton.disabled = false;
                submitButtonSpan.textContent = 'Add to Bag';
            } else {
                submitButton.classList.add('disabled');
                submitButton.disabled = true;
                submitButtonSpan.textContent = 'Sold Out';
            }
        }
      // Disable out-of-stock variants for the selected product
      for (let [key, variant] of variantMap) {
        var sizeRadio = document.querySelector(
          'input[name="size"][value="' + key.split(color)[0] + '"]'
        );
        var colorRadio = document.querySelector(
          'input[name="color"][value="' + key.split(size)[1] + '"]'
        );
        if (variant.inventory <= 0 && variant.inventory_policy !== 'continue') {
          if (sizeRadio) {
            sizeRadio.classList.add("disabled");
          }
          if (colorRadio) {
            colorRadio.classList.add("disabled");
          }
        } else {
          if (sizeRadio) {
            sizeRadio.classList.remove("disabled");
          }
          if (colorRadio) {
            colorRadio.classList.remove("disabled");
          }
        }
      }
    };
  }
  
  function updateProductVariantId(variantId) {
    document.getElementById("product-variant-id").value = variantId;
  }

  function updateUrlWithVariantId(variantId) {
    const url = new URL(window.location);
    url.searchParams.set('variant', variantId);
    window.history.pushState({}, '', url);
  }

  // Handler for option selector click event
  function handleOptionSelectorClick(e) {
    const optionSelector = e.target.closest(".option-selector");
    if (optionSelector) {
      // Remove active class from all children
      Array.from(e.currentTarget.children).forEach((child) => {
        child.classList.remove("active");
      });
  
      // Add active class to clicked element
      optionSelector.classList.add("active");
  
      // Get the index from data-index attribute
      const index = optionSelector.getAttribute("data-index");
  
      // Get the product select dropdown
      const productSelect = document.getElementById("product-select");
  
      // Change the selected index of product select dropdown
      productSelect.selectedIndex = index;
  
      // Manually dispatch the 'change' event on the dropdown
      productSelect.dispatchEvent(new Event('change'));
    }
  }
  
  
function updateSlides(variant) {
    // Skip media updates for preorder template
    if (isPreorderTemplate) {
        return;
    }
    
    const mediaList = document.querySelector("#Slider-Gallery");
    
    // Add the transition class to the media list
    mediaList.classList.add("transition");
    
    // Set a delay for the transition class to take effect
    setTimeout(() => {
        if (variant.featured_image_alt) {
            document
                .querySelectorAll("[variant-alt]")
                .forEach((slide) => slide.classList.add("variant-hidden"));
            
            const alternateImages = `[variant-alt='${variant.featured_image_alt}']`;
            document
                .querySelectorAll(alternateImages)
                .forEach((slide) => slide.classList.remove("variant-hidden"));
        } else {
            document
                .querySelectorAll("[variant-alt]")
                .forEach((slide) => slide.classList.remove("variant-hidden"));
        }
        
        // Check how many images are visible now
        const visibleImages = document.querySelectorAll("[variant-alt]:not(.variant-hidden)").length;
        
        // If only one image is left, add the class. Otherwise, remove it.
        if (visibleImages === 1) {
            mediaList.classList.add("one-media-item");
        } else {
            mediaList.classList.remove("one-media-item");
        }
        
        // Remove the transition class after the changes have taken effect
        mediaList.classList.remove("transition");
        
        imgSwipe();
    }, 400); // delay of half a second to match the CSS transition
}
  
  function handleMedia(product) {
    var sliderGallery = document.getElementById("Slider-Gallery");
    sliderGallery.innerHTML = ""; // clear previous content
    if (product && product.media) {
      product.media.forEach((media) => {
        var li = document.createElement("li");
        li.id = "Slide-"+media.id;
        li.classList.add("product__media-item", "slider__slide");
        li.setAttribute("variant-alt", media.alt);
  
        var div = document.createElement("div");
        div.classList.add("product__media", "media--transparent");
  
        var img = document.createElement("img");
        img.src = media.preview_image + "?width=900";
        img.alt = media.alt;
  
        div.appendChild(img);
        li.appendChild(div);
        sliderGallery.appendChild(li);

      });
    }
    imgSwipe();
  }
  
  function populateOptions(set, id, variantMap, product) {
    var sizeOrder = ["40", "44", "48", "52", "56", "58", "XS", "S", "M", "L", "XL", "2XL", "3XL"];
    var sizeLabel = {"40": "S (40)", "44": "M (44)", "48": "L (48)", "52": "XL (52)", "56": "2XL (56)", "58": "3XL (58)"};
    
    // Filter out hidden variants before creating the set
    var filteredSet = new Set();
    set.forEach(item => {
        // Check if this option should be shown
        let shouldShow = false;
        for (let [key, variant] of variantMap) {
            if (id === "size" && key.startsWith(item)) {
                if (variant.hide !== "true") {
                    shouldShow = true;
                    break;
                }
            } else if (id === "color" && key.endsWith(item)) {
                if (variant.hide !== "true") {
                    shouldShow = true;
                    break;
                }
            } else if (id === "style" && key.endsWith(item)) {  // Add this
                if (variant.hide !== "true") {
                    shouldShow = true;
                    break;
                }
            }
        }
        if (shouldShow) {
            filteredSet.add(item);
        }
    });

    var orderedSet;
    if (id === "size") {
        orderedSet = Array.from(filteredSet).sort(function(a, b) {
            return sizeOrder.indexOf(a) - sizeOrder.indexOf(b);
        });
    } else {
        orderedSet = Array.from(filteredSet);
    }

    var i = 0;
    orderedSet.forEach((item) => {
        var radioButton = document.createElement("input");
        radioButton.setAttribute("type", "radio");
        radioButton.setAttribute("name", id);
        radioButton.setAttribute("id", item);
        radioButton.setAttribute("value", item);
        if (id === "size") {
            radioButton.classList.add("pill-radio");
        }
        if (id === "color") {
            radioButton.classList.add("pill-swatch");
        }
        if (id === "style") {
            radioButton.classList.add("pill-radio");
        }

        if (i === 0) {
            radioButton.setAttribute("checked", "checked");
        }

        // Check inventory and hide status
        let isAvailable = false;
        for (let [key, variant] of variantMap) {
            if (id === "size" && key.startsWith(item)) {
                if ((variant.inventory > 0 || variant.inventory_policy === 'continue') && variant.hide !== "true") {
                    isAvailable = true;
                    break;
                }
            } else if (id === "color" && key.endsWith(item)) {
                if ((variant.inventory > 0 || variant.inventory_policy === 'continue') && variant.hide !== "true") {
                    isAvailable = true;
                    break;
                }
            } else if (id === "style" && key.endsWith(item)) {  // Add this condition
                if ((variant.inventory > 0 || variant.inventory_policy === 'continue') && variant.hide !== "true") {
                    isAvailable = true;
                    break;
                }
            }
        }
        
        if (!isAvailable) {
            radioButton.classList.add("disabled");
        }

        if (i === 0 && !radioButton.disabled) {
            radioButton.setAttribute("checked", "checked");
            i++;
        }

        var label = document.createElement("label");
        if (id === "size" && sizeLabel[item]) {
            label.textContent = sizeLabel[item];
        } else {
            label.textContent = item;
        }
        label.setAttribute("for", item);

        if (id === "size") {
            label.classList.add("pill");
        }
        else if (id === "style" && isPreorderTemplate) {
            // Style selector only for preorder
            let stylePrice = null;
            for (let [key, variant] of variantMap) {
                if (key.includes(item)) {
                    stylePrice = variant.price;
                    break;
                }
            }
            
            label.classList.add("style-selector");
            label.innerHTML = `
                <div class="style-option swatch-details flex flex-col justify-center text-center">
                    <span class="swatch-name">${item}</span>
                    ${stylePrice ? `<span class="swatch-price">${stylePrice}</span>` : ''}
                </div>
            `;
        }

        else if (id === "color") {
              if (isPreorderTemplate && product) {
                // Find the price for this color variant
                let variantPrice = null;
                let variantName = item; // Default to color name
                
                // Look through variants to find one with this color
                for (let [key, variant] of variantMap) {
                    if (key.endsWith(item)) {
                        variantPrice = variant.price;
                        break; // Use the first variant with this color for pricing
                    }
                }
                
                // Get custom display name if needed
                const colorDisplayNames = {
                    'Association': 'Association',
                    'Icon': 'Icon', 
                    'Statement': 'Statement',
                    'City': 'City',
                    'City 26': 'City 26', 
                    'Classic': 'Classic'
                };
                
                const displayName = colorDisplayNames[item] || item;
                
                label.classList.add( "preorder-swatch");
                label.innerHTML = `
                    <div class="swatch-details flex flex-col justify-center text-center">
                        <span class="swatch-name">${displayName}</span>
                        ${variantPrice ? `<span class="swatch-price">${variantPrice}</span>` : ''}
                    </div>
                `;                
            } else {
              label.classList.add("swatch");
              label.innerHTML = '<div class="swatch-field ' + item + '"></div>' + item + "";
            }
        }
        
        // Add safety check
        const optionsElement = document.getElementById(id + "-options");
        if (!optionsElement) {
            console.error(`Element with id "${id}-options" not found`);
            return;
        }
    optionsElement.appendChild(radioButton);
    optionsElement.appendChild(label);
            i++;
        });
        
      // Update event listeners
      const selectors = isPreorderTemplate ? 
          'input[name="size"], input[name="style"]' : 
          'input[name="size"], input[name="color"]';
      
      document.querySelectorAll(selectors).forEach(inputElement => {
          inputElement.addEventListener('change', handleProductFormChange(variantMap));
      });
}
  